<template>
  <div class="fyranolltre">
    <h1>Behörighet saknas</h1>
      <div v-if="error === 'AccessDeniedForHandläggare'">
      <h2>Åtkomst nekad</h2>
        <p> Jobskills sökgränssnitt är från och med fredagen den 11 maj bara tillgängligt för arbetsgivare och aktörer med arbetsgivarkonto hos Arbetsförmedlingen. Du som jobbar på Arbetsförmedlingen kan inte längre logga in i söktjänsten.</p>
        <p> Bakgrunden till stängningen är att vi gör en översyn av hur Jobskills möter upp mot registerlagstiftningen. Vi tittar samtidigt på vilka möjligheter vi har att låta handläggare söka i Jobskillsdatabasen.</p>
        <p> Om du vill informera om och visa hur Jobskills sökgränssnitt fungerar så kommer du inom kort kunna använda dig av vår demonstrationsdatabas. Information om hur du kommer till denna kommer inom kort.</p>
        <p> Det går givetvis fortfarande bra att använda informationen från Jobskills vid inskrivningen t ex genom att personen som ska skriva in sig tar med sig en utskrift av sin Jobskillsprofil till inskrivningssamtalet. Planerna på att integrera Jobskills med AIS/Mina sidor så att informationen kan föras över digitalt finns kvar.</p>
        <p> Det går också fint att hjälpa arbetsgivare som ber om stöd att göra urval i söktjänsten tillsammans med dem t ex genom att ni sitter ihop eller delar skärm. (När vi gör detta måste vi säkerställa att vi efter genomförd stödinsats inte behåller någon information om individen eller sökningen.)</p>
        <br>
        <p> Hälsningar Jobskillsteamet</p>
      </div>
      <div v-else>
      <p>
        Du saknar behörighet att söka på Jobskills.se
      </p>
      </div>
  </div>
</template>
<script>
export default {
  name: 'accessdenied',
  data: function() {
    return {
      error: ''
    }
  },
  created: function() {
    this.error = this.$route.query.error
  }
}
</script>
<style lang="postcss" scoped>
.fyranolltre {
  margin: 100px auto;
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/403.vue